export default __webpack_public_path__ + "static/media/PH_DRUG.94ff0b56.jpg";